export { AngularMultiSelect } from './multiselect.component';
export { ClickOutsideDirective } from './clickOutside';
export { ListFilterPipe } from './list-filter';
export { Item } from './menu-item';
export { TemplateRenderer } from './menu-item';
export { AngularMultiSelectModule } from './multiselect.component';
//# sourceMappingURL=angular2-multiselect-dropdown.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/node_modules/angular2-multiselect-dropdown/angular2-multiselect-dropdown.js
// module id = ../../../../angular2-multiselect-dropdown/angular2-multiselect-dropdown.js
// module chunks = vendor